module.exports = __webpack_public_path__ + "img/icon-envelope-light-active.c82ece0d.svg";